/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Authentication API
 * This Authentification API for Kazaar
 * OpenAPI spec version: 1.3.2
 */

export type PermissionItem = typeof PermissionItem[keyof typeof PermissionItem];


export const PermissionItem = {
  accountsaccountsmanagement: 'accounts.accounts.management',
  accountsaccountsread: 'accounts.accounts.read',
  accountsorganizationsmanagement: 'accounts.organizations.management',
  accountsorganizationsread: 'accounts.organizations.read',
  accountsworkspacesmanagement: 'accounts.workspaces.management',
  accountsworkspacesread: 'accounts.workspaces.read',
  accountsdashboardsread: 'accounts.dashboards.read',
  authrolesmanagement: 'auth.roles.management',
  authrolesread: 'auth.roles.read',
  authusersmanagement: 'auth.users.management',
  authusersread: 'auth.users.read',
  authapikeymanagement: 'auth.apikey.management',
  authapikeyread: 'auth.apikey.read',
  omsbriefsmanagement: 'oms.briefs.management',
  omsbriefsread: 'oms.briefs.read',
  omsbriefsvalidate: 'oms.briefs.validate',
  imsattributesmanagement: 'ims.attributes.management',
  imsattributesread: 'ims.attributes.read',
  imscollectionsmanagement: 'ims.collections.management',
  imscollectionsread: 'ims.collections.read',
  imschannelsmanagement: 'ims.channels.management',
  imschannelsread: 'ims.channels.read',
  imsoffersmanagement: 'ims.offers.management',
  imsoffersread: 'ims.offers.read',
  imsproductsarchive: 'ims.products.archive',
  imsproductsmanagement: 'ims.products.management',
  imsproductsread: 'ims.products.read',
  notificationsnotificationsread: 'notifications.notifications.read',
  notificationsnotificationsmanagement: 'notifications.notifications.management',
  imsstocksmanagement: 'ims.stocks.management',
  imsstocksread: 'ims.stocks.read',
  imswarehousesmanagement: 'ims.warehouses.management',
  imswarehousesread: 'ims.warehouses.read',
  omsdeliverymanagement: 'oms.delivery.management',
  omsdeliveryread: 'oms.delivery.read',
  omsordersmanagement: 'oms.orders.management',
  omsordersread: 'oms.orders.read',
  omsproofsmanagement: 'oms.proofs.management',
  omsproofsread: 'oms.proofs.read',
  omsquotesmanagement: 'oms.quotes.management',
  omsquotesread: 'oms.quotes.read',
  omsreportsread: 'oms.reports.read',
  attributesprivateMetadatamanagement: 'attributes.privateMetadata.management',
  attributesprivateMetadataread: 'attributes.privateMetadata.read',
  kazaaradminmanagement: 'kazaar.admin.management',
} as const;
